import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=0cc5bfbc&scoped=true&"
import script from "./ExpensesList.vue?vue&type=script&lang=js&"
export * from "./ExpensesList.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=0cc5bfbc&lang=scss&scoped=true&"
import style1 from "./ExpensesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5bfbc",
  null
  
)

export default component.exports